import { Component, inject, OnInit } from '@angular/core';
import { GTMSegmentService } from '../services/gtm-segment.service';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-update-popup',
  templateUrl: './update-popup.component.html',
  styleUrls: ['./update-popup.component.scss'],
  standalone: true,
  imports: [IonicModule],
})
export class UpdatePopupComponent implements OnInit {
  private GTMSegment = inject(GTMSegmentService);

  constructor() {
    this.GTMSegment.GTMPopupInitialization("UpdatePopup");
  }

  ngOnInit() { }
    
}
